import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-alert-urgent',
    templateUrl: './alert-urgent.component.html',
    styleUrls: ['./alert-urgent.component.css'],
    standalone: false
})
export class AlertUrgentComponent implements OnInit {

  @Input()
  message!:string;

  constructor() { }

  ngOnInit(): void {
  }

}
